var regions = {
  'ap-northeast-1': {
    domain: 'ecs-buy-ap-northeast-1.aliyun.com',
    isOpen: true
  },
  'ap-south-1': { domain: 'ecs-buy-ap-south-1.aliyun.com', isOpen: true },
  'ap-southeast-1': { isOpen: false },
  'ap-southeast-2': {
    domain: 'ecs-buy-ap-southeast-2.aliyun.com',
    isOpen: true
  },
  'ap-southeast-3': {
    domain: 'ecs-buy-ap-southeast-3.aliyun.com',
    isOpen: true
  },
  'ap-southeast-5': {
    domain: 'ecs-buy-ap-southeast-5.aliyun.com',
    isOpen: true
  },
  center: { isOpen: false },
  'cn-huhehaote': { domain: 'ecs-buy-cn-huhehaote.aliyun.com', isOpen: true },
  'cn-zhangjiakou': {
    domain: 'ecs-buy-cn-zhangjiakou.aliyun.com',
    isOpen: true
  },
  'eu-central-1': { domain: 'ecs-buy-eu-central-1.aliyun.com', isOpen: true },
  'me-east-1': { domain: 'ecs-buy-me-east-1.aliyun.com', isOpen: true },
  'us-west-1': { isOpen: false }
};

export default regions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/ecs/EcsRegion.js
// module id = 161
// module chunks = 0